<template>
  <div>
    <p class="part-title">实验简介
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('introduce')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openIntroduce"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <p class="tips">（实验的必要性及实用性，教学设计的合理性，实验系统的先进性）</p>
    <div
      class="part-content"
      v-if="!formInfo.introduce"
    >暂无内容，请进行维护</div>
    <div
      class="part-content"
      v-if="formInfo.introduce"
      v-html="formInfo.introduce"
    ></div>
    <p class="part-title">实验教学目标
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('tech_goal')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openTechGoal"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <p class="tips">（实验后应达到的知识、能力水平）</p>
    <div
      class="part-content"
      v-if="!formInfo.tech_goal"
    >暂无内容，请进行维护</div>
    <div
      class="part-content"
      v-if="formInfo.tech_goal"
      v-html="formInfo.tech_goal"
    ></div>
    <p class="part-title">实验课时
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('class_hour')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openClassHour"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">实验所属课程课时：</span>
      <div>
        <span class="content_underline">{{formInfo.time_lesson?formInfo.time_lesson:'暂无内容'}}</span>学时
      </div>
      <span class="content-title">该实验所占课时：</span>
      <div>
        <span class="content_underline">{{formInfo.time_experiment?formInfo.time_experiment:'暂无内容'}}</span>学时
      </div>
    </div>
    <p class="part-title">实验原理
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('theory')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openTheory"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <div class="content-title content-text-change">(1) 实验原理：
        <span class="tips">（限1000字以内）
        </span>
      </div>
      <div
        class="content-text content-text-change"
        v-if="!formInfo.theory_content"
      >暂无内容</div>
      <div
        class="content-text content-text-change"
        v-if="formInfo.theory_content"
        v-html="formInfo.theory_content"
      >暂无内容</div>
      <div class="clearfix"></div>
      <span class="content-title">知识点数量：</span>
      <div v-if="formInfo.theory_point"><b>{{ formInfo.theory_point.length }}</b> 个</div>
      <div v-else><b>0</b> 个</div>
      <div class="clearfix"></div>
      <span class="content-title"></span>
      <div
        class="content-text"
        v-if="formInfo.theory_point.length > 0"
      >
        <ol>
          <li
            v-for="(item, index) in formInfo.theory_point"
            :key="index"
          >
            ({{ index + 1 }}) {{ item.content }}
          </li>
        </ol>
      </div>
      <div
        class="content-text"
        v-else
      >暂无内容</div>
      <div class="clearfix"></div>
      <div class="content-title content-text-change">(2) 核心要素仿真设计：
        <span class="tips">（对系统或对象的仿真模型体现的客观结构、功能及其运动规律的实验场景进行如实描述，限500字以内）
        </span>
      </div>
      <div
        class="content-text content-text-change"
        v-if="!formInfo.theory_core"
      >暂无内容</div>
      <div
        class="content-text content-text-change"
        v-if="formInfo.theory_core"
        v-html="formInfo.theory_core"
      ></div>
    </div>
    <p class="part-title">实验教学过程与实验方法
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('tech_func')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openTechFunc"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div
      class="part-content"
      v-if="!formInfo.tech_func"
    >暂无内容，请进行维护</div>
    <div
      class="part-content"
      v-if="formInfo.tech_func"
      v-html="formInfo.tech_func"
    ></div>
    <p class="part-title">步骤要求
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('step')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openStep"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="tips">（不少于10步的学生交互性操作步骤。操作步骤应反映实质性实验交互，系统加载之类的步骤不计入在内）</div>
    <div class="part-content"><span class="content-title">（1）学生交互性操作步骤：</span>
      <div class="content-text">共{{formInfo.step_claim_step.length?formInfo.step_claim_step.length:'--'}}步</div>
      <div class="clearfix"></div>
      <div class="content-text-table">
        <table class="part-new-table">
          <tbody>
            <tr class="l_header">
              <th width="50">序号</th>
              <th width="120">
                <p>步骤名称</p>
                <p class="th-sub">（100字以内）</p>
              </th>
              <th width="200">
                <p>步骤目标要求</p>
                <p class="th-sub">（100字以内）</p>
              </th>
              <th width="110">
                <p>步骤合理用时</p>
                <p class="th-sub">（分钟）</p>
              </th>
              <th width="200">
                <p>目标达成度赋分模型</p>
                <p class="th-sub">（200字以内）</p>
              </th>
              <th width="80">步骤满分</th>
              <th width="130">成绩类型</th>
            </tr>

            <tr
              v-for="(item,index) in formInfo.step_claim_step"
              :key="index"
            >
              <td>{{index+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.target}}</td>
              <td>{{item.useTime}}</td>
              <td>{{item.model}}</td>
              <td>{{item.score}}</td>
              <td><label class="check-label check-label-block"><input
                    type="checkbox"
                    disabled=""
                    v-model="item.scoreType"
                    value="1"
                  >预习成绩</label><label class="check-label check-label-block"><input
                    type="checkbox"
                    disabled=""
                    v-model="item.scoreType"
                    value="2"
                  >操作成绩</label><label class="check-label check-label-block"><input
                    type="checkbox"
                    disabled=""
                    checked=""
                    v-model="item.scoreType"
                    value="3"
                  >实验报告</label><label class="check-label check-label-block"><input
                    type="checkbox"
                    disabled=""
                    v-model="item.scoreType"
                    value="4"
                  >教师评价报告</label></td>
            </tr>

          </tbody>
        </table>
      </div>
      <div class="clearfix"></div><span class="content-title">（2）交互性步骤详细说明：</span>
      <div class="clearfix"></div>
      <div
        class="content-text no-float"
        v-if="!formInfo.step_claim_step_des"
      >暂无内容</div>
      <div
        class="content-text no-float"
        v-if="formInfo.step_claim_step_des"
        v-html="formInfo.step_claim_step_des"
      >暂无内容</div>
    </div>
    <p class="part-title">实验结果与结论
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('experiment_result')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openExperimentResult"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <p class="tips">（说明在不同实验条件和操作下可能产生的实验结果与结论）</p>
    <div class="part-content">
      <div
        class="content-text"
        v-if="!formInfo.experiment_result"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.experiment_result"
        v-html="formInfo.experiment_result"
      >暂无内容</div>
    </div>
    <p class="part-title">面向学生要求
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('student')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openStudent"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">专业与年级要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.student_claim_subject"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.student_claim_subject"
        v-html="formInfo.student_claim_subject"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">基本知识和能力要求：</span>
      <div
        class="content-text"
        v-if="!formInfo.student_claim_content"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.student_claim_content"
        v-html="formInfo.student_claim_content"
      ></div>
    </div>
    <p class="part-title">实验应用及共享情况
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('proj')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openProj"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">本校上线时间：</span>
      <div class="content-text">{{this.formInfo.share_situation.onlineTime?this.formInfo.share_situation.onlineTime:'暂无内容'}}</div>
      <div class="clearfix"></div>
      <span class="content-title">系统日志：</span>
      <div
        class="content-text preview"
        @click="getPreviewInfo(1)"
      >{{this.formInfo.share_situation.systemLogName?this.formInfo.share_situation.systemLogName:'暂无内容'}}</div>
      <div class="clearfix"></div>
      <span class="content-title">已服务过的本校学生人数：</span>
      <div class="content-text">{{this.formInfo.share_situation.studentNum?this.formInfo.share_situation.studentNum:'暂无内容'}}</div>
      <div class="clearfix"></div>
      <span class="content-title">已服务过的外校学生人数：</span>
      <div class="content-text">{{this.formInfo.share_situation.studentNum2?this.formInfo.share_situation.studentNum2:'暂无内容'}}</div>
      <div class="clearfix"></div>
      <div class="clearfix"></div>
      <span class="content-title">所属课程教学计划或授课提纲：</span>
      <div
        class="content-text preview"
        @click="getPreviewInfo(2)"
      >{{this.formInfo.share_situation.courseTextName?this.formInfo.share_situation.courseTextName:'暂无内容'}}</div>
      <div class="clearfix"></div><span class="content-title">纳入教学计划的专业数：</span>
      <div class="content-text">{{formInfo.share_situation.subjectList?formInfo.share_situation.subjectList.length:'--'}}</div>
      <div class="clearfix"></div><span class="content-title">具体专业：</span>
      <div
        class="content-text"
        style="margin-right:10px"
        v-for="(item,index) in formInfo.share_situation.subjectList"
        :key="index"
      >{{item.subjectTitle}}</div>
      <!-- <div class="clearfix"></div><span class="content-title">教学周期：</span>
      <div class="content-text">1</div>
      <div class="clearfix"></div><span class="content-title">学习人数：</span>
      <div class="content-text">{{this.formInfo.share_situation.subjectList?this.formInfo.share_situation.subjectList:'暂无内容'}}</div> -->
      <div class="clearfix"></div><span class="content-title">是否面向社会提供服务：</span>
      <div class="content-text">{{this.formInfo.share_situation.societyNum?this.formInfo.share_situation.societyNum:'暂无内容'}}</div>
      <div class="clearfix"></div>
    </div>
    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.introduce)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">实验简介</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
          @click="showWindow.introduce = false"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form style="">
            <vue-ueditor-wrap
              v-model="formIntroduce.introduce"
              :config="editorConfig"
              editor-id="editor-demo-01"
            ></vue-ueditor-wrap>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.introduce = false"
            class="button close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveIntroduce"
            class="button"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.tech_goal)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">实验教学目标</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
          @click="showWindow.tech_goal = false"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form style="">
            <vue-ueditor-wrap
              v-model="formTechGoal.tech_goal"
              :config="editorConfig"
              editor-id="editor-demo-02"
            ></vue-ueditor-wrap>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.tech_goal = false"
            class="button close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveTechGoal"
            class="button"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      id="CMS_overlay"
      :style="formatShowWindow(showWindow.class_hour)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">实验课时</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.class_hour = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="CMSForm">
            <div class="item">
              <span class="label"><i class="require">*</i>实验所属课程课时</span>
              <div>
                <input
                  v-model="formClassHour.time_lesson"
                  type="number"
                  class="form-control"
                  maxlength="25"
                >
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>该实验所占课时</span>
              <div>
                <input
                  v-model="formClassHour.time_experiment"
                  type="number"
                  class="form-control"
                  maxlength="25"
                >
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.class_hour = false"
            class="button close"
            id="CMS_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveClassHour"
            class="button"
            id="CMS_submit"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      id="basis_overlay"
      :style="formatShowWindow(showWindow.theory)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">实验原理</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
        ><i class="iconfont"></i>

        </a>
        <div
          class="form_content"
          style=""
        >
          <form
            id="basisForm"
            style=""
          >
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>实验原理说明</span>
              <vue-ueditor-wrap
                style="margin-left: 110px;"
                v-model="formTheory.theory_content"
                :config="editorConfig"
                editor-id="editor-demo-04"
              ></vue-ueditor-wrap>
            </div>
            <div class="item">
              <span class="label">知识点数量：</span>
              <span id="pNumber">{{ theoryPointList.length }}</span>
              <span>个</span>
            </div>
            <div class="item">
              <span class="label">&nbsp;</span>
              <a
                href="javascript:;"
                @click="addTheoryPoint"
                class="button"
              >新增知识点</a>
            </div>
            <div id="pBox">
              <div
                class="item"
                v-for="(item, index) in theoryPointList"
                :key="index"
              >
                <span class="label"><i class="require"></i>（{{ index + 1 }}）</span>
                <textarea
                  v-model="item.content"
                  class="form-control simple pointsText"
                  style="height:60px;"
                ></textarea>
                <a
                  href="javascript:;"
                  style="color:#ff0000;margin-left:12px;"
                  @click="delTheoryPoint(index)"
                >删除</a>
              </div>
            </div>
            <div class="item hide">
              <span class="label"><i class="require"></i>知识点数量</span>
              <input
                type="text"
                class="form-control"
                maxlength="25"
              >
            </div>
            <div
              class="item hide"
              style=""
            >
              <span class="label"><i class="require"></i>步骤</span>
              <vue-ueditor-wrap
                style="margin-left: 110px;"
                :config="editorConfig"
                editor-id="editor-demo-05"
              ></vue-ueditor-wrap>
            </div>
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>核心要素仿真设计</span>
              <textarea
                v-model="formTheory.theory_core"
                class="simple"
                placeholder="（对系统或对象的仿真模型体现的客观结构、功能及其运动规律的实验场景进行如实描述，限500字以内）"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            @click="showWindow.theory = false"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            @click="saveTheory"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.tech_func)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">实验教学过程与实验方法</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
          @click="showWindow.tech_func = false"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form style="">
            <vue-ueditor-wrap
              v-model="formTechFunc.tech_func"
              :config="editorConfig"
              editor-id="editor-demo-06"
            ></vue-ueditor-wrap>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.tech_func = false"
            class="button close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveTechFunc"
            class="button"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.step)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel editor">
        <div class="form_title">步骤要求</div>
        <div
          class="form_content"
          style=""
        >
          <form
            id="testWayForm"
            style=""
          >
            <div class="item">
              <p class="line-title">学生交互性操作步骤
                <span class="step-num">共{{formStep.step_claim_step.length?formStep.step_claim_step.length:'--'}}步</span>
              </p>
              <div class="k-container step-container">
                <div class="step-box">
                  <div class="f_list">
                    <table class="item-table">

                      <tr class="l_header">
                        <th width="40">序号</th>
                        <th>
                          <p>步骤名称</p>
                          <p class="th-sub">（100字以内）</p>
                        </th>
                        <th>
                          <p>步骤目标要求</p>
                          <p class="th-sub">（100字以内）</p>
                        </th>
                        <th width="100">
                          <p>步骤合理用时</p>
                          <p class="th-sub">（分钟）</p>
                        </th>
                        <th>
                          <p>目标达成度赋分模型</p>
                          <p class="th-sub">（200字以内）</p>
                        </th>
                        <th width="70">步骤满分</th>
                        <th width="130">成绩类型</th>
                        <th width="50">操作</th>
                      </tr>
                      <tbody v-if="formStep.step_claim_step.length>0">
                        <tr
                          class="step-data"
                          v-for="(item,index) in formStep.step_claim_step"
                          :key="index"
                        >
                          <td>{{index+1}}</td>
                          <td><textarea
                              v-model="item.name"
                              maxlength="100"
                            ></textarea><span class="wordCount">还可以输入<em>{{formatNum(100,item.name)}}</em>字</span></td>
                          <td><textarea
                              v-model="item.target"
                              maxlength="100"
                            ></textarea><span class="wordCount">还可以输入<em>{{formatNum(100,item.target)}}</em>字</span></td>
                          <td><input
                              type="number"
                              v-model="item.useTime"
                            ></td>
                          <td><textarea
                              v-model="item.model"
                              maxlength="200"
                            ></textarea>
                            <span class="wordCount">还可以输入<em>{{formatNum(200,item.model)}}</em>字</span>
                          </td>
                          <td><input
                              type="number"
                              v-model="item.score"
                            ></td>
                          <td>
                            <label class="check-label"><input
                                type="checkbox"
                                v-model="item.scoreType"
                                value="1"
                              >预习成绩</label>
                            <label class="check-label"><input
                                type="checkbox"
                                checked=""
                                v-model="item.scoreType"
                                value="2"
                              >操作成绩</label>
                            <label class="check-label"><input
                                type="checkbox"
                                v-model="item.scoreType"
                                value="3"
                              >实验报告</label>
                            <label class="check-label"><input
                                type="checkbox"
                                v-model="item.scoreType"
                                value="4"
                              >教师评价报告</label>
                          </td>
                          <td><a
                              href="javascript:"
                              class="action-btn delete"
                              @click="delStepItem(index)"
                            ><i class="icon iconfont">&#xe614;</i></a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="add-one-step button"
                  title="新增一步"
                  @click="addStep"
                ><i class="icon iconfont">&#xe6ea;</i>

                </div>
              </div>
            </div>

            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>交互性步骤详细说明</span>
              <vue-ueditor-wrap
                style="margin-left: 110px;"
                v-model="formStep.step_claim_step_des"
                :config="editorConfig"
                editor-id="editor-demo-17"
              ></vue-ueditor-wrap>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.step = false"
            class="button close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveStep"
            class="button"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.experiment_result)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">实验结果与结论</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
          @click="showWindow.experiment_result = false"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form style="">
            <vue-ueditor-wrap
              v-model="formExperimentResult.experiment_result"
              :config="editorConfig"
              editor-id="editor-demo-07"
            ></vue-ueditor-wrap>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.experiment_result = false"
            class="button close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveExperimentResult"
            class="button"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      id="toStuReq_overlay"
      :style="formatShowWindow(showWindow.student)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">面向学生要求</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.student = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form
            id="toStuReqForm"
            style=""
          >
            <div class="item">
              <span class="label"><i class="require"></i>专业与年级要求</span>
              <input
                type="text"
                v-model="formStudent.student_claim_subject"
                class="form-control"
                maxlength="30"
              >
            </div>
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>基本知识和能力要求等</span>
              <vue-ueditor-wrap
                style="margin-left: 110px;"
                v-model="formStudent.student_claim_content"
                :config="editorConfig"
                editor-id="editor-demo-13"
              ></vue-ueditor-wrap>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.student = false"
            class="button close"
            id="toStuReq_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveStudent"
            class="button"
            id="toStuReq_submit"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="formatShowWindow(showWindow.proj)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">实验应用及共享情况</div>
        <div class="form_content">
          <form id="proUseForm">
            <div class="item">
              <span class="label"><i class="require"></i>本校上线时间</span>
              <input
                type="date"
                class="form-control"
                v-model="formProj.onlineTime"
              >
            </div>
            <div class="item sysLog">
              <span class="label"><i class="require"></i>系统日志</span>
              <div class="item-box clearfix">
                <div
                  class="attach-list"
                  v-if="formProj.systemLogName"
                >
                  <a>{{formProj.systemLogName}}</a>
                  <span
                    class="del"
                    @click="delLog()"
                  >
                    x
                  </span>
                </div>
                <span
                  class="button"
                  @click="showFileWindow(1)"
                >上传</span>
              </div>
              <div class="clearfix"></div>
              <div class="imgMsg">注：需提供经过2个教学周期实践检验，且具有可追溯的学生在线学习记录。包含实验记录唯一ID、学号/用户名、真实姓名、所在学校/单位、实验名称、实验开始时间、实验结束时间、实验成绩等数据，以Excel文件提交</div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>已服务过的本校学生人数</span>
              <input
                type="number"
                min="0"
                class="form-control"
                v-model="formProj.studentNum"
                maxlength="10"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>已服务过的外校学生人数</span>
              <input
                type="number"
                class="form-control"
                v-model="formProj.studentNum2"
                maxlength="10"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>所属课程教学计划或授课提纲
              </span>
              <div class="item-box clearfix">
                <div
                  class="attach-list01"
                  v-if="formProj.courseTextName"
                >

                  <a>{{formProj.courseTextName}}</a>
                  <span
                    class="del"
                    @click="delCourseText"
                  >
                    x
                  </span>
                </div>
                <span
                  class="button"
                  id="attPath01"
                  @click="showFileWindow(2)"
                >上传</span>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>纳入教学计划的专业数</span>
              <div class="item-box subject-num clearfix">共{{formProj.subjectList?formProj.subjectList.length:'--'}}个</div>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>具体专业</span>
              <div class="k-container subject-wrap">
                <div class="subject-box">
                  <div
                    class="item-input"
                    v-for="(item,index) in formProj.subjectList"
                    :key="index"
                  >
                    <input
                      class="subject-name"
                      type="text"
                      value=""
                      v-model="item.subjectTitle"
                      maxlength="30"
                    ><span
                      class="del"
                      @click="delSubject(index)"
                    >x</span>
                  </div>
                </div>
                <div
                  class="add-one-subject button"
                  title="新增一个专业"
                  @click="addSubject"
                ><i class="icon iconfont">&#xe6ea;</i>

                </div>
              </div>
              <div class="clear"></div>
            </div>

            <div class="item">
              <span class="label"><i class="require"></i>是否面向社会提供服务</span>
              <select
                type="text"
                class="form-control isToSociety"
                v-model="formProj.isToSociety"
                @change="clearProjItem"
              >
                <option value="">请选择</option>
                <option value="1">是</option>
                <option value="2">否</option>
              </select>
            </div>
            <div v-if="formProj.isToSociety==1">
              <div class="item societyInfo">
                <span class="label"><i class="require"></i>社会开放时间</span>
                <input
                  type="date"
                  class="form-control laydate-icon"
                  v-model="formProj.openTime"
                >
              </div>
              <div class="item societyNum societyInfo">
                <span class="label"><i class="require"></i>已服务过的社会学习者人数</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="formProj.societyNum"
                  maxlength="10"
                >
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.proj = false"
            class="button close"
            id="toStuReq_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveProj"
            class="button"
            id="toStuReq_submit"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      id="file-upload-overlay"
      :style="showWindow.bigFile ? 'display: block' : ''"
    >
      <div class="file-upload-bg"></div>
      <div class="file-upload">
        <div
          class="file-upload-type"
          v-show="toggleUpload==1"
        >允许上传的文件扩展名：xls,xlsx</div>
        <div
          class="file-upload-type"
          v-show="toggleUpload==2"
        >允许上传的文件扩展名：pdf</div>
        <div
          class="file-upload-close"
          @click="hideFileWindow"
        >×</div>
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          style="display: block;"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            :accept="toggleUpload == 1 ? '.xls,.xlsx' : '.pdf'"
            ref="docFile"
            style="display: block;"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            style="display: none;"
          ></div>
          <div
            class="pbar"
            :style="showWindow.bigFileOption.showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(showWindow.bigFileOption.progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{ showWindow.bigFileOption.progressValue }}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div
      id="res-preview-overlay"
      :style="formatShowWindow(showWindow.preview)"
    >
      <div id="res-preview-overlay-bg"></div>
      <div id="res-preview-panel">
        <div id="res-preview-title">{{previewInfo.title_name}}
          <div
            id="res-preview-close"
            @click="showWindow.preview = false"
          >x</div>
        </div>
        <div id="res-preview-content">
          <div v-if="previewInfo.previewType==1">
            <excel-view :datas="previewInfo.excelData"></excel-view>
          </div>
          <div
            class="pdf-region"
            v-else
          >
            <pdf
              :page="pageNum"
              :src="previewInfo.previewPath"
              @progress="loadedRatio = $event"
              @num-pages="pageTotalNum=$event"
            ></pdf>
            <div class="pagecolor">
              <span @click="prePage">上一页 </span> {{ pageNum }} / {{ pageTotalNum }} <span @click="nextPage"> 下一页</span>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import ExcelView from '../../../../components/ExcelView'
import pdf from 'vue-pdf'
export default {
  name: 'ExperimentMaintainDes',
  components: {
    VueUeditorWrap,
    pdf,
    ExcelView
  },
  props: ['isShow', 'expId'],
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      theoryPointList: [],
      showWindow: {
        tech_goal: false,
        introduce: false,
        class_hour: false,
        theory: false,
        tech_func: false,
        experiment_result: false,
        student: false,
        proj: false,
        step: false,
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        },
        preview: false
      },
      formInfo: {
        tech_goal: '',
        theory_content: '',
        theory_point: '',
        theory_core: '',
        time_lesson: '',
        time_experiment: '',
        introduce: '',
        tech_func: '',
        experiment_result: '',
        student_claim_subject: '',
        student_claim_content: '',
        step_claim_step: [],
        step_claim_step_des: '',
        share_situation: {}
      },
      // 实验简介表单数据
      formIntroduce: {
        introduce: ''
      },
      // 实验教学目标表单数据
      formTechGoal: {
        tech_goal: ''
      },
      // 实验课时表单数据
      formClassHour: {
        time_lesson: '',
        time_experiment: ''
      },
      // 实验原理表单数据
      formTheory: {
        theory_content: '',
        theory_point: '',
        theory_core: ''
      },
      // 实验教学过程与实验方法表单数据
      formTechFunc: {
        tech_func: ''
      },
      // 步骤要求表单数据
      formStep: {
        step_claim_step: [],
        step_claim_step_des: ''
      },
      // 实验结果与结论表单数据
      formExperimentResult: {
        experiment_result: ''
      },
      // 面向学生要求表单数据
      formStudent: {
        student_claim_subject: '',
        student_claim_content: ''
      },
      // 实验应用及共享情况表单数据
      formProj: {
        onlineTime: '',
        systemLogPath: '',
        systemLogName: '',
        studentNum: '',
        studentNum2: '',
        courseTextName: '',
        courseTextPath: '',
        subjectList: [],
        isToSociety: '2',
        openTime: '',
        societyNum: ''
      },
      stepInfo: [],
      toggleUpload: 1,

      previewInfo: {
        previewType: '',
        title_name: '',
        previewPath: '',
        excelData: null
      },
      sensitiveWord: []
    }
  },
  methods: {
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    getPreviewInfo(val) {
      this.previewInfo.previewType = val

      if (val === 2) {
        if (this.formInfo.share_situation.courseTextName) {
          this.previewInfo.title_name = this.formInfo.share_situation.courseTextName
          this.previewInfo.previewPath = this.formInfo.share_situation.courseTextPath
          this.showWindow.preview = true
        } else {
          this.showWindow.preview = false
        }
      } else if (val === 1) {
        if (this.formInfo.share_situation.systemLogName) {
          this.previewInfo.title_name = this.formInfo.share_situation.systemLogName
          this.previewInfo.previewPath = this.formInfo.share_situation.systemLogPath
          this.showWindow.preview = true
          const layerload = this.$layer.loading({
            time: 5
          })
          this.$http.get(this.$store.state.api + this.previewInfo.previewPath, {
            responseType: 'arraybuffer',
            baseURL: ''
          }).then((res) => {
            this.$layer.close(layerload)
            this.previewInfo.excelData = res
          })
        } else {
          this.showWindow.preview = false
        }
      }
    },
    formatNum(num, val) {
      var value = val ? val.length : 0
      return Number(num - value)
    },
    clearProjItem(e) {
      if (e.target.value !== '1') {
        this.formProj.openTime = ''
        this.formProj.societyNum = ''
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.step_claim_step = data.step_claim_step ? JSON.parse(data.step_claim_step) : []
        this.formInfo.share_situation = data.share_situation ? JSON.parse(data.share_situation) : ''
        this.formInfo.theory_point = data.theory_point ? JSON.parse(data.theory_point) : ''
      }).catch((error) => {
        console.log(error)
      })
    },
    showFileWindow(val) {
      if (this.isShow) {
        this.toggleUpload = val
        this.showWindow.bigFile = true
      }
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    async fileChange() {
      if (this.$store.state.max_file_size && this.$refs.docFile.files[0].size > this.$store.state.max_file_size) {
        alert('文件大小超过限制！')
        return false
      }
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        if (this.toggleUpload === 1) {
          this.formProj.systemLogName = fileRealName
          this.formProj.systemLogPath = data
        } else {
          this.formProj.courseTextName = fileRealName
          this.formProj.courseTextPath = data
        }
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
      }).catch((error) => {
        console.log(error)
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    /**
     * 根据字段打开/关闭相应的弹窗
     */
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    /**
     * 打开实验简介弹窗
     */
    openIntroduce() {
      this.showWindow.introduce = true
      this.formIntroduce.introduce = this.formInfo.introduce
    },
    /**
     * 打开实验教学目标弹窗
     */
    openTechGoal() {
      this.formTechGoal.tech_goal = this.formInfo.tech_goal
      this.showWindow.tech_goal = true
    },
    /**
     * 打开实验课时目标弹窗
     */
    openClassHour() {
      this.formClassHour.time_lesson = this.formInfo.time_lesson
      this.formClassHour.time_experiment = this.formInfo.time_experiment
      this.showWindow.class_hour = true
    },
    /**
     * 打开实验原理弹窗
     */
    openTheory() {
      this.formTheory.theory_content = this.formInfo.theory_content
      this.formTheory.theory_point = [...this.formInfo.theory_point]
      this.formTheory.theory_core = this.formInfo.theory_core
      this.theoryPointList = this.formInfo.theory_point ? [...this.formInfo.theory_point] : []
      this.showWindow.theory = true
    },
    /**
     * 打开实验教学过程与实验方法弹窗
     */
    openTechFunc() {
      this.formTechFunc.tech_func = this.formInfo.tech_func
      this.showWindow.tech_func = true
    },
    /**
     * 打开步骤要求弹窗
     */
    openStep() {
      this.formStep = {
        step_claim_step: this.formInfo.step_claim_step ? [...this.formInfo.step_claim_step] : [],
        step_claim_step_des: this.formInfo.step_claim_step_des ? this.formInfo.step_claim_step_des : ''
      }
      this.showWindow.step = true
    },
    /**
     * 打开实验结果与结论弹窗
     */
    openExperimentResult() {
      this.formExperimentResult.experiment_result = this.formInfo.experiment_result
      this.showWindow.experiment_result = true
    },
    /**
     * 打开面向学生要求弹窗
     */
    openStudent() {
      this.formStudent.student_claim_subject = this.formInfo.student_claim_subject
      this.formStudent.student_claim_content = this.formInfo.student_claim_content
      this.showWindow.student = true
    },
    /**
     * 打开实验应用及共享情况弹窗
     */
    openProj() {
      this.formProj = {
        onlineTime: this.formInfo.share_situation.onlineTime ? this.formInfo.share_situation.onlineTime : '',
        systemLogPath: this.formInfo.share_situation.systemLogPath ? this.formInfo.share_situation.systemLogPath : '',
        systemLogName: this.formInfo.share_situation.systemLogName ? this.formInfo.share_situation.systemLogName : '',
        studentNum: this.formInfo.share_situation.studentNum ? this.formInfo.share_situation.studentNum : '',
        studentNum2: this.formInfo.share_situation.studentNum2 ? this.formInfo.share_situation.studentNum2 : '',
        courseTextName: this.formInfo.share_situation.courseTextName ? this.formInfo.share_situation.courseTextName : '',
        courseTextPath: this.formInfo.share_situation.courseTextPath ? this.formInfo.share_situation.courseTextPath : '',
        subjectList: this.formInfo.share_situation.subjectList ? this.formInfo.share_situation.subjectList : [],
        isToSociety: this.formInfo.share_situation.isToSociety ? this.formInfo.share_situation.isToSociety : '2',
        openTime: this.formInfo.share_situation.openTime ? this.formInfo.share_situation.openTime : '',
        societyNum: this.formInfo.share_situation.societyNum ? this.formInfo.share_situation.societyNum : ''
      }

      this.showWindow.proj = true
    },
    /**
     * 保存实验简介
     */
    async saveIntroduce() {
      const url = '/experiment/' + this.expId + '/'
      const isRight = this.utils.getWords(this.formIntroduce.introduce, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, this.formIntroduce).then((data) => {
        if (data.id) {
          this.formInfo.introduce = this.formIntroduce.introduce
          this.showWindow.introduce = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    /**
     * 保存实验教学目标
     */
    async saveTechGoal() {
      const url = '/experiment/' + this.expId + '/'
      const isRight = this.utils.getWords(this.formTechGoal.tech_goal, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, this.formTechGoal).then((data) => {
        if (data.id) {
          this.formInfo.tech_goal = this.formTechGoal.tech_goal
          this.showWindow.tech_goal = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    /**
     * 保存实验课时
     */
    async saveClassHour() {
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, this.formClassHour).then((data) => {
        if (data.id) {
          this.formInfo.time_lesson = this.formClassHour.time_lesson
          this.formInfo.time_experiment = this.formClassHour.time_experiment
          this.showWindow.class_hour = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    addTheoryPoint() {
      this.theoryPointList.push({ content: '' })
    },
    delTheoryPoint(index) {
      this.theoryPointList.splice(index, 1)
    },
    /**
     * 保存实验原理
     */
    async saveTheory() {
      this.formTheory.theory_point = JSON.stringify(this.theoryPointList)
      const url = '/experiment/' + this.expId + '/'
      const isRight = this.utils.getWords(this.formTheory.theory_content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, this.formTheory).then((data) => {
        if (data.id) {
          this.formInfo.theory_content = this.formTheory.theory_content
          this.formInfo.theory_point = JSON.parse(this.formTheory.theory_point)
          this.formInfo.theory_core = this.formTheory.theory_core
          this.showWindow.theory = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    /**
     * 保存实验教学过程与实验方法
     */
    async saveTechFunc() {
      const url = '/experiment/' + this.expId + '/'
      const isRight = this.utils.getWords(this.formTechFunc.tech_func, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, this.formTechFunc).then((data) => {
        if (data.id) {
          this.formInfo.tech_func = this.formTechFunc.tech_func
          this.showWindow.tech_func = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    addStep() {
      const stepItem = {
        name: '',
        target: '',
        useTime: '',
        model: '',
        score: '',
        scoreType: []
      }
      this.formStep.step_claim_step.push(stepItem)
    },
    delStepItem(index) {
      this.formStep.step_claim_step.splice(index, 1)
    },
    /**
     * 保存步骤要求
     */
    async saveStep() {
      const url = '/experiment/' + this.expId + '/'
      const params = {
        step_claim_step: JSON.stringify(this.formStep.step_claim_step),
        step_claim_step_des: this.formStep.step_claim_step_des
      }
      const isRight = this.utils.getWords(this.formStep.step_claim_step_des, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, params).then((data) => {
        if (data.id) {
          this.getInfo(data.id)
          // this.formInfo.step_claim_step = JSON.parse(this.formStep.step_claim_step)
          // this.formInfo.step_claim_step_des = this.formStep.step_claim_step_des
          this.showWindow.step = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    /**
     * 保存实验结果与结论
     */
    async saveExperimentResult() {
      const url = '/experiment/' + this.expId + '/'
      const isRight = this.utils.getWords(this.formExperimentResult.experiment_result, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, this.formExperimentResult).then((data) => {
        if (data.id) {
          this.formInfo.experiment_result = this.formExperimentResult.experiment_result
          this.showWindow.experiment_result = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    /**
     * 保存面向学生要求
     */
    async saveStudent() {
      const url = '/experiment/' + this.expId + '/'
      const isRight = this.utils.getWords(this.formStudent.student_claim_content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.put(url, this.formStudent).then((data) => {
        if (data.id) {
          this.formInfo.student_claim_content = this.formStudent.student_claim_content
          this.formInfo.student_claim_subject = this.formStudent.student_claim_subject
          this.showWindow.student = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    addSubject() {
      const subjectList = {
        subjectTitle: ''
      }
      this.formProj.subjectList.push(subjectList)
    },
    delCourseText() {
      this.formProj.courseTextPath = ''
      this.formProj.courseTextName = ''
    },
    delLog() {
      this.formProj.systemLogPath = ''
      this.formProj.systemLogName = ''
    },
    delSubject(index) {
      this.formProj.subjectList.splice(index, 1)
    },
    /**
     * 保存实验应用及共享情况
     */
    async saveProj() {
      const params = {
        share_situation: JSON.stringify(this.formProj)
      }
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, params).then((data) => {
        if (data.id) {
          this.getInfo(data.id)
          // this.formInfo.share_situation = this.formProj
          this.showWindow.proj = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    /**
     * 清空对应模块的数据
     */
    clearItem(categgory) {
      switch (categgory) {
        case 'introduce':
          this.formIntroduce = {
            introduce: ''
          }
          this.saveIntroduce()
          break
        case 'tech_goal':
          this.formTechGoal = {
            tech_goal: ''
          }
          this.saveTechGoal()
          break
        case 'class_hour':
          this.formClassHour = {
            time_lesson: '',
            time_experiment: ''
          }
          this.saveClassHour()
          break
        case 'tech_func':
          this.formTechFunc = {
            tech_func: ''
          }
          this.saveTechFunc()
          break
        case 'theory':
          this.formTheory = {
            theory_content: '',
            theory_point: [],
            theory_core: ''
          }
          this.theoryPointList = []
          this.saveTheory()
          break
        case 'experiment_result':
          this.formExperimentResult = {
            experiment_result: ''
          }
          this.saveExperimentResult()
          break
        case 'student':
          this.formStudent = {
            student_claim_subject: '',
            student_claim_content: ''
          }
          this.saveStudent()
          break
        case 'step':
          this.formStep = {
            step_claim_step: [],
            step_claim_step_des: ''
          }
          this.saveStep()
          break
        case 'proj':
          this.formProj = {}
          this.saveProj()
          break
      }
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getInfo()
    this.getSensitiveWord()
  }
}
</script>

<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>
<style scoped src="../../../../assets/css/project-infor-2020.css"></style>

<style lang="less" scoped>
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: baseline;
}
.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 100px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
.content_underline {
  text-decoration: underline;
  margin: 0 10px;
}
.content-text-change {
  float: unset;
}

.form_content .imgMsg {
  padding-left: 110px;
}
.form_content .k-container .step-box .item-table {
  width: 100%;
  margin-bottom: 20px;
}
.form_content .item .step-box input[type="radio"],
.form_content .item .step-box input[type="checkbox"] {
  margin-right: 10px;
  margin-top: -2px !important;
}
.form_content .k-container .item-table .check-label input {
  width: unset;
}
.form_content .subject-wrap {
  width: unset;
  max-width: unset;
}
.check-label-block {
  display: block;
}
input[type="date"] {
  width: 380px;
  padding: 6px 12px;
  height: inherit;
  line-height: 1.42857143;
  border: 1px solid #dddddd;
  box-sizing: border-box;
}
/deep/#res-preview-overlay {
  visibility: hidden;
}
#res-preview-close {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid red;
  text-align: center;
  line-height: 20px;
}
.pdf-region {
  max-height: 560px;
  overflow-y: scroll;
}
.preview {
  color: #73D6CA;
  cursor: pointer;
}
.pagecolor {
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
  span:hover {
    color: #73D6CA;
    cursor: pointer;
  }
}
</style>
